function Cancellation({ terms }: any) {
  return (
    <div className="mt-6 rounded-md border border-secondary-100 bg-bg-color p-4">
      <div className="mb-8">
        <h1 className="text-lg font-bold text-text-color ">Cancellation</h1>
        <p className="max-96 text-sm text-text-color">
          {/* Please note the following booking Terms and Conditions apply to
          bookings placed directly on the {companyData?.name} website. */}
        </p>
      </div>
      <div className="col-span-12 @container">
        <div className="flex flex-col gap-y-4">
          {terms?.map((item: any, i: number) => {
            return (
              <div
                className="rounded-md border border-secondary-100 border-muted"
                key={i}
              >
                <div className="header rounded-md bg-[#f7f7f7]] px-5 py-3">
                  <h4 className="text-lg">
                    {i + 1}. {item?.title}
                  </h4>
                </div>
                <div className="header border-t border-secondary-100 border-muted p-5 w-full">
                  <div className="grid grid-cols-1 gap-3 rounded-md w-full">
                    <div
                      className="prose prose-sm text-text-color  break-words"
                      style={{ maxWidth: "100%" }} // Manually remove the max width
                      dangerouslySetInnerHTML={{ __html: item?.content }}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Cancellation;
